import FeatureRouteGuard from "./FeatureRouteGuard";

const ProfilesRouteGuard = ({
  children,
  redirectTo,
  billingOnly = false,
}: {
  children: React.ReactNode;
  redirectTo?: string;
  /**
   * Skip the `profile.view` check — for the Settings > Properties pages,
   * which are admin configuration gated on the Profiles subscription, not
   * the Profiles module itself.
   */
  billingOnly?: boolean;
}) => (
  <FeatureRouteGuard
    flag="profiles_enabled"
    permission={billingOnly ? undefined : "profile.view"}
    defaultEnabled
    redirectTo={redirectTo}
  >
    {children}
  </FeatureRouteGuard>
);

export default ProfilesRouteGuard;
